import logoMainForm from "../../assets/images/logo-main-form.png";
import React, {
  useRef,
  useState
} from "react";
import { MessageForm } from "./widgets/MessageForm";
import { getValueFromInputElement } from "../../utils/inputRefHandlers";
import { setStatusFormAlert } from "../../hooks/AlertsForm";
import { userAuthentication } from "../../api/user/userService";
import { useContext } from "react";
import { Context } from "../../App";

export function Login(props) {
  const { setAndGetUserData } = useContext(Context);
  const { setSessionForm } = props;
  const inputRefs = useRef({ email: "", password: "" });
  const [hasProcessingInformation, setHasProcessingInformation] = useState(false);
  const [formRequestStatus, setFormRequestStatus] = useState({
    typeAlert: "",
    message: ""
  });
  const timeToRemoveMessage = useRef(0);
  const handleLogin = async (e) => {
    e.preventDefault();
    const email = inputRefs.current.email;
    const password = inputRefs.current.password;
    setHasProcessingInformation(true);
    const bodyRequest = {
      email,
      senha: password
    };
    userAuthentication(bodyRequest).then((data) => {
      setHasProcessingInformation(false);
      let statusHttp = data["statusHttp"];
      if (statusHttp === 200) {
        setStatusFormAlert(
          data,
          "alert-success",
          setFormRequestStatus,
          timeToRemoveMessage
        );
        let response = { "data": data.user_data };
        setAndGetUserData(response);
      } else if (statusHttp === 404 || statusHttp === 401) {
        let typeAlert = statusHttp === 404 ? "alert-danger" : "alert-warning";
        setStatusFormAlert(
          data,
          typeAlert,
          setFormRequestStatus,
          timeToRemoveMessage
        );
      } else if (statusHttp === 0) {
        let typeAlert = "alert-danger";
        setStatusFormAlert(
          data,
          typeAlert,
          setFormRequestStatus,
          timeToRemoveMessage
        );
      }
    });
  };

  return (
    <div className="home-px-5 d-flex align-items-center justify-content-center home-container-form">
      <div className="home-area-form">
        <span className="home-container-main-icon-form">
          <img
            src={logoMainForm}
            alt="Ícone de parceiros"
            className="home-main-icon-form"
          />
        </span>
        <br />

        <MessageForm
          formRequestStatus={formRequestStatus}
          hasProcessingInformation={hasProcessingInformation}
        />

        <br />
        <span className="home-form-title">Acesse sua conta</span>
        <div>
          <form className="w-100" onSubmit={handleLogin}>
            <div
              className="home-field-form-to-fill"
              data-validate="Enter email"
            >
              <input
                className="home-input-form"
                type="email"
                name="email"
                placeholder="E-mail"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="📧"
              ></span>
            </div>
            <div
              className="home-field-form-to-fill"
              data-validate="Enter password"
            >
              <input
                className="home-input-form"
                type="password"
                name="password"
                placeholder="Senha"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="🔐"
              ></span>
            </div>

            <div className="home-container-btn-submit-form">
              <button className="home-btn-submit-form" type="submit">
                Entrar
              </button>
            </div>
            <hr />
          </form>
          <div className="home-container-other-option-form">
            <div className="home-sub-container-other-option-form">
              <div className="col d-flex">
                <a
                  className="home-text-other-option-form text-start"
                  onClick={() => {
                    setSessionForm("register");
                  }}
                >
                  <p>Cadastrar</p>
                </a>
              </div>
              <div className="col d-flex">
                <a
                  className="home-text-other-option-form text-end"
                  onClick={() => {
                    setSessionForm("forgot_password");
                  }}
                >
                  Esqueceu sua senha?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
